var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "layout",
    style: _vm.colorObject
  }, [_c('div', {
    staticClass: "container"
  }, [_c('header', {
    staticClass: "border-bottom"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center p-2 px-3"
  }, [_c('router-link', {
    staticClass: "logo",
    attrs: {
      "to": {
        name: 'LiffShopProducts'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.meta.image
    }
  })]), _c('div', [_vm._m(0), _c('router-link', {
    staticClass: "p-2 btn position-relative",
    attrs: {
      "to": {
        name: 'LiffShopCart'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon-cart.svg")
    }
  }), _c('small', {
    staticClass: "badge badge-pill badge-danger position-absolute"
  }, [_vm._v("1")])]), _c('button', {
    staticClass: "p-2 btn",
    on: {
      "click": function click($event) {
        _vm.isSearching = !_vm.isSearching;
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon-search.svg")
    }
  })])], 1)], 1), _vm.isSearching ? _c('div', {
    staticClass: "search px-3 py-2 d-flex align-items-center shadow shadow-sm"
  }, [_vm._m(1), _c('button', {
    staticClass: "btn text-black text-nowrap font-weight-bolder",
    on: {
      "click": function click($event) {
        _vm.isSearching = !_vm.isSearching;
      }
    }
  }, [_vm._v(" 取消 ")])]) : _vm._e()]), _c('router-view')], 1)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', {
    staticClass: "p-2 btn"
  }, [_c('img', {
    attrs: {
      "src": require("./images/icon-user.svg")
    }
  })]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "search-box p-2 px-3 flex-fill d-flex align-items-center"
  }, [_c('img', {
    staticClass: "icon mr-2",
    attrs: {
      "src": require("./images/icon-search.svg")
    }
  }), _c('input', {
    staticClass: "box",
    attrs: {
      "type": "text",
      "placeholder": "搜尋"
    }
  })]);
}]

export { render, staticRenderFns }